// How an attempt ended (quiz_attempts.end_reason), as shown to trainers.
// Attempts finished before this was recorded have no reason and show nothing.
export const END_REASON_LABELS = {
  candidate: 'Submitted by candidate',
  timer: 'Time expired (auto-submitted)',
  server: 'Time expired (closed by server)',
  trainer: 'Closed by trainer'
};
